<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  interface Props {
    checked?: boolean;
    id?: string;
    name?: string;
    children?: import('svelte').Snippet;
  }

  let {
    checked = $bindable(false),
    id = '',
    name = '',
    children
  }: Props = $props();

  const dispatch = createEventDispatcher();

  function handleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    checked = target.checked;
    dispatch('change', { checked });
  }
</script>

<style>
  .custom-checkbox {
    display: flex;
    align-items: center;
  }

  .checkbox-wrapper {
    position: relative;
    width: 20px;
    height: 20px;
    margin-right: 2px;
    border: 1px solid rgb(86 103 137);
    border-radius: 25px;


  }

  input[type="checkbox"] {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    cursor: pointer;
    outline: none;
    background: transparent;
    position: relative;
  }

  input[type="checkbox"]:checked {
    background-color: #FEED97;
    border-color: #FEED97;

  }

  input[type="checkbox"]:checked::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 3px;
    width: 8px;
    height: 12px;
    border: solid black;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  label {
    cursor: pointer;
  }
</style>

<div class="custom-checkbox">
  <div class="checkbox-wrapper">
    <input
      type="checkbox"
      name={name}
      bind:checked={checked}
      onchange={handleChange}
      id={id}
    />
  </div>
  <label for={id}>
    {@render children?.()}
  </label>
</div>
